<template>
  <v-container class="privatstep6 dmb-form-text padding-confirm pa-0" fluid>
    <v-row no-gutters>
      <v-col cols="12"
             class="ueber primary--text stepperless--header">Vielen Dank für Ihren {{ antragName }}!
      </v-col>

      <v-col cols="12"
             class="muchtext">Ihr {{ antragName }} ist am
        <strong>{{ germanDate }}</strong> um
        <strong>{{ germanTime }} Uhr</strong> bei der DMB Rechtsschutz eingegangen und wird umgehend bearbeitet.
        <br><br> Bis zur Policierung wird der {{ antragName }} mit der unten genannten Vorgangsnummer in der Kundenverwaltung im Menüpunkt offene Anträge angezeigt.
        <span v-if="!aenderung">Nach der Policierung befindet sich der Versicherungsvertrag in der Kundenverwaltung im Menüpunkt Bestandsverträge.</span>
        <br>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <div>
        <strong>Vorgangsnummer: {{ angebotsnummer }}</strong>
      </div>
    </v-row>

    <v-row no-gutters>
      <v-col class="muchtext">

        <template v-if="!aenderung">
          <br>
          <span>

            <template v-if="invitatio==='N'">
              Bei Abschluss lagen dem Kunden und/oder Ihnen als bevollmächtigter Person rechtzeitig das
            </template>

            <template v-else>
              Bei Abschluss lagen dem Kunden das
            </template>

            <template v-if="produktInformationsBlattLink && arbLink">
              <a :href="produktInformationsBlattLink"
                 target="_blank">Produktinformationsblatt</a>, die
              <a :href="arbLink + '#page=3&zoom=100'"
                 target="_blank">Allgemeinen Vertragsinformationen</a> und die
              <a :href="arbLink"
                 target="_blank">{{ arbTitle }}</a>
            </template>

            <template v-else>
              Produktinformationsblatt, die Allgemeinen Vertragsinformationen und die {{ arbTitle }}
            </template>

            <template v-if="invitatio==='N'">
              vor.
            </template>

            <template v-else>
              nicht oder nicht rechtzeitig vor.<br><br>
              Der Kunde erhält ein Angebot, welches er verbindlich annehmen muss, um Versicherungsschutz zu erhalten. Der Vertrag kommt erst zustande, wenn die DMB Rechtsschutz die
              <span style="text-decoration:none">Annahmeerklärung des Kunden</span> erhalten hat!
            </template>

          </span>
          <br>
        </template>


        <br> Bei Fragen zum {{ antragName }} wenden Sie sich bitte an unseren Maklerservice unter
        <span class="nobreak"><a href="mailto:maklerservice@dmb-rechtsschutz.de">maklerservice@dmb-rechtsschutz.de</a></span>. Wir sind gerne für Sie da und freuen uns auf die weiterhin gute Zusammenarbeit!
        <br>
        <br>
      </v-col>

    </v-row>
    <v-row no-gutters justify="center">
      <v-btn :href="pdflink"
             target="_blank"
             color="primary"
             class="standard-button">{{ antragName }} herunterladen&nbsp;
        <v-icon>file_download</v-icon>
      </v-btn>
    </v-row>

    <v-row no-gutters
           class="stepperbuttons">
      <v-btn color="primary"
             class="standard-button"
             @click="aenderung ? $router.push('/offeneAntraege') : $router.go()">{{ aenderung ? 'Zur Antragsliste' : 'Neues Angebot Privatkunden' }}
      </v-btn>
      <v-spacer />
      <v-btn color="primary"
             class="standard-button"
             @click="$router.push('/start')">Zur Start-Seite
      </v-btn>
    </v-row>

  </v-container>
</template>

<script>
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import contentLoadingMixin from "@/components/helper/contentLoadingMixin";
import {API_URL_SERVER} from "@/helper/httpService";

export default {
  mixins: [twowayBinding, contentLoadingMixin(["ARB", "ARB_SUS", "PI_Standard", "PI_EXPERT", "PI_PRESTIGE", "PI_SUS", "ARB_YOLIG", "PI_YOLIG"])],
  props: {
    aenderung: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    ...mapTwoWay(["invitatio", "submitTime", "pdfpfad", "angebotsnummer", "sus", "productLine"]),
    yolig() {
      return this.productLine === 'YOLIG';
    },
    germanTime() {
      return this.submitTime.split(" ")[1];
    },
    germanDate() {
      return this.submitTime.replace(",", "").split(" ")[0];
    },
    pdflink () {
      return API_URL_SERVER + this.pdfpfad + "?disposition=inline";
    },
    produktInformationsBlattLink () {
      if (!this.PI_Standard || !this.PI_PRESTIGE || !this.PI_EXPERT || !this.PI_SUS) return null;
      
      if(this.sus) return this.PI_SUS.items[0].link;
      
      let url = this.PI_Standard.items[0].link;
      switch (this.productLine)  {
        case 'STD':
          url = this.PI_Standard.items[0].link;
          break;
        case 'EXP':
          url = this.PI_EXPERT.items[0].link;
          break;
        case 'PRE':
          url = this.PI_PRESTIGE.items[0].link;
          break;
        case "YOLIG":
          url = this.PI_YOLIG.items[0].link;
          break;
      }
      return url;
    },
    arbTitle () {
      if(this.sus) {
        return this.ARB_SUS ? this.ARB_SUS.items[0].title : 'ARB Schnell und Sicher';
      } else if(this.yolig) {
        return this.ARB_YOLIG ? this.ARB_YOLIG.items[0].title : 'ARB YOLIG';
      } else {
        return this.ARB ? this.ARB.items[0].title : 'ARB';
      }
    },
    arbLink () {
      if(this.sus){
        return this.ARB_SUS ? this.ARB_SUS.items[0].link : null;
      } else if(this.yolig) {
        return this.ARB_YOLIG ? this.ARB_YOLIG.items[0].link : null;
      } else {
        return this.ARB ? this.ARB.items[0].link : null;
      }
    },
    antragName() {
      return this.aenderung ? "Änderungsantrag" : "Antrag";
    }
  }
};
</script>
<style>
.privatstep6 {
  max-width: 768px !important;
}

.privatstep6 .stepperless--header {
  padding-top: 44px; /*font-lh/2= 4 + container margin 16 + pt = 64  */
  padding-bottom: 24px;
}

.margin-content {
  margin-bottom: 48px;
}

/* Blocksatz disabled */
.muchtext {
  hyphens: manual;
  /*text-align: justify;*/
}

span.nobreak {
  white-space: nowrap;
}
</style>
